import { Component, OnInit } from '@angular/core';
import { MasterDataService } from '../../services/master-data.service';
import { NgModel } from '@angular/forms';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-monthly-conveyance-report',
  templateUrl: './monthly-conveyance-report.component.html',
  styleUrls: ['./monthly-conveyance-report.component.css'],
})
export class MonthlyConveyanceReportComponent implements OnInit {
  selectedFinancialYear;
  financialList;
  branchList;
  closingDateList;
  selectedClosing;
  selectedEmployee;
  selectedRole;
  roleList;
  selectedBranch;
  isRoleSelected = false;
  isBranchSelected = false;
  monthlyConveyanceList;
  chargableTotal;
  nonChargableTotal;
  allChargablenonChargableTotal;
  closingDate;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService, private branchFilterService: BranchFilterService) { }

  ngOnInit(): void {
    this.selectedFinancialYear = '';
    this.selectedClosing = '';
    this.selectedEmployee = '1';
    this.selectedBranch = '';
    this.loadInitialDetails();
  }

  loadInitialDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });

    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });

    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });

    this.masterDataService.getRoles().subscribe((res) => {
      this.roleList = res;
    });
  }

  onFinancialYearSelected() {
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
          var notClosedobject = {
            id: 0,
            closingDate: 'Not Closed',
          };
          this.closingDateList.push(notClosedobject);
          console.log('closing date list', this.closingDateList);
        });
    }
    this.selectedClosing = '';
  }

  selectAllRole(select: NgModel, values) {
    this.selectAll(select, values, this.isRoleSelected, false);
    this.isRoleSelected = !this.isRoleSelected;
  }
  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
  }
  selectAll(select: NgModel, values, isSelected, isId) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  onViewReport() {
    if (
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == '' ||
      this.selectedClosing == null ||
      this.selectedClosing == '' ||
      this.selectedBranch == null ||
      this.selectedBranch.length === 0 ||
      this.selectedRole == null ||
      this.selectedRole.length === 0
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }
    const roleId = this.selectedRole.map(({ id }) => id);
    const branchId = this.selectedBranch.map(({ id }) => id);
    console.log('closing date id', this.selectedClosing.id);
    console.log('role id', roleId);
    console.log('branch id', branchId);
    console.log('selectedEmployee status', this.selectedEmployee);
    this.masterDataService
      .getMonthlyConveyanceReport(this.selectedClosing.id, roleId, branchId, this.selectedEmployee)
      .subscribe((res) => {
        console.log('monthly conveyance report', res);
        this.monthlyConveyanceList = res;
        if (this.monthlyConveyanceList == null) {
          this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found.');
        }
      });
  }
  getChargableTotal(branchDetails) {
    this.chargableTotal = 0;
    branchDetails.map((res) => {
      res.details.map((res1) => {
        this.chargableTotal += res1.chargeble;
      });
    });
    return Math.round(this.chargableTotal);
  }
  getNonChargableTotal(branchDetails) {
    this.nonChargableTotal = 0;
    branchDetails.map((res) => {
      res.details.map((res1) => {
        this.nonChargableTotal += res1.nonChargeble;
      });
    });
    return Math.round(this.nonChargableTotal);
  }

  getAllChargableNonChargableTotal(branchDetails) {
    this.allChargablenonChargableTotal = 0;
    branchDetails.map((res) => {
      res.details.map((res1) => {
        this.allChargablenonChargableTotal +=
          res1.chargeble + res1.nonChargeble;
      });
    });
    return Math.round(this.allChargablenonChargableTotal);
  }
}
